import { render, staticRenderFns } from "./project-batch.vue?vue&type=template&id=7fd462ba&scoped=true"
import script from "./project-batch.vue?vue&type=script&lang=js"
export * from "./project-batch.vue?vue&type=script&lang=js"
import style0 from "./project-batch.vue?vue&type=style&index=0&id=7fd462ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd462ba",
  null
  
)

export default component.exports